export type Report = {
    reportName: string;
    reportDisplayName: string;
    reportGroup: string;
    reportType: ReportType;

    embedRole?: string;
    fmtpRoute?: string;
    powerBiDatasets?: ReportDataset[];
    powerBiReportName?: string;
    powerBiGroupId?: string;
    sigmaPath?: string;
    sigmaReportName?: string;
    reportCatalog?: string; //Sigma Report Catalog
};

export type ReportDataset = {
    datasetId: string;
    embedRole?: string;
};

export enum ReportType {
    Sigma = 'Sigma',
    PowerBi = 'Power BI',
    PowerBiPaginated = 'Power BI Paginated',
    Fmtp = 'FMTP',
}
